import accountSvg from 'assets/image/icons/svg/account.svg'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { LinkedInNotLogged } from 'components/molecules/linkedInNotLogged/LinkedInNotLogged'
import { HomeTemplate } from 'components/templates/homeTemplate'
import { MailboxUI } from 'features/messaging'
import { teamHooks } from 'features/team'
import { useEffect } from 'react'
import { leftSideHooks, useActionCreators, useAppSelector } from 'shared/hooks'

import { appActions, appSelectors } from '../redux/reducers/app'

const leftSide: leftSideHooks.LeftSideInput = {
	bottomList: [
		{
			id: 1,
			image: accountSvg,
			link: '/messaging',
			title: ' Messaging'
		}
	],
	type: 'messaging'
}

export function MessagingPage() {
	const hasAutomation = useAppSelector(appSelectors.hasAutomation)

	const { changePage } = useActionCreators(appActions)
	const isPersonReady = teamHooks.useParamPerson()

	useEffect(() => {
		if (hasAutomation) {
			changePage('/messaging')
		}
	}, [hasAutomation, changePage])

	leftSideHooks.useLeft(leftSide)

	const shouldShowMailbox = isPersonReady && hasAutomation
	const shouldShowEmpty = isPersonReady && !hasAutomation

	return (
		<HomeTemplate>
			<LinkedInNotLogged />

			{!isPersonReady && <FullLoader size={60} />}
			{shouldShowMailbox && (
				<>
					<MailboxUI.Mailbox />
					<MailboxUI.DeleteMessage />
				</>
			)}

			{shouldShowEmpty && <MailboxUI.Empty />}
		</HomeTemplate>
	)
}
